export function pxToRem(px) {
  return (px / 12) + 'rem'
}